<!-- 添加附件 -->
<template>
  <a-upload
    :beforeUpload="beforeUpload"
    :show-upload-list="false"
    :custom-request="_uploadFile"
    :disabled="loading"
  >
    <slot></slot>
  </a-upload>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
    }
  },
  props: ['suffixs', 'maxSize', 'type'],
  mounted() {},
  methods: {
    validateSuffix(file) {
      const suffixs = this.suffixs
      if (!suffixs) {
        return true
      }
      const suffix = file.name
        .toLowerCase()
        .split('.')
        .splice(-1)
        .join('')
      if (suffixs.includes(suffix)) {
        return true
      }
      this.$message.warning(`仅支持${suffixs.join(', ')}格式`)
      return false
    },
    validateSize(file) {
      const maxSize = this.maxSize
      if (!maxSize) {
        return true
      }
      const size = file.size
      if (size < maxSize * 1024 * 1024) {
        return true
      }
      this.$message.warning(`上传文件大小不能超过 ${maxSize}MB`)
      return false
    },
    validate(file) {
      const validateMethods = ['validateSuffix', 'validateSize']
      return validateMethods.every(method => {
        return this[method](file)
      })
    },

    beforeUpload(file) {
      if (this.loading) {
        return
      }
      const check = this.validate(file)
      if (!check) {
        return false
      }
    },
    async _uploadFile(file) {
      this.loading = true
      const crtFile = file.file
      const formData = new FormData()
      formData.append('file', crtFile)
      formData.append('type', this.type)
      this.$emit('ok', formData)
    },
    // 暴露给父组件的方法
    stopLoading() {
      this.loading = false
    },
  },
}
</script>

<style lang="less" scoped></style>
